import { useContext } from "react";
import { Snack, Snackbar } from "@nike/eds";
import SnackbarContext, {SnackbarStatus} from "../providers/snackbar-context";
import React from "react";

export function ApplicationSnackbar() {
    const snackbarCtx = useContext(SnackbarContext);

    return (
        <Snackbar>
            {(() => {
                if (snackbarCtx.status === SnackbarStatus.success) {
                    return (
                        <Snack id="success" status="success" onDismiss={snackbarCtx.onClose}>
                            {snackbarCtx.msg}
                        </Snack>
                    )
                } else if (snackbarCtx.status === SnackbarStatus.error) {
                    return (
                        <Snack id="error" status="error" onDismiss={snackbarCtx.onClose}>
                            {snackbarCtx.msg}
                        </Snack>
                    )
                } else {
                    return (
                        <Snack id="error" status="neutral" onDismiss={snackbarCtx.onClose}>
                            {snackbarCtx.msg}
                        </Snack>
                    )
                }
            })()}
        </Snackbar>
    )
}
